import { Unstable_Grid2 as Grid } from '@mui/material';

import { TextField, Typography } from '@occc-app/design-system';

import { MarketingContentFormValuesPaths } from './types';
import { PHYSICAL_RECEIPT_LABEL_OVERRIDE_HELPER_TEXT } from './messages';

const formNamePrefix = 'receiptContent';

export const PhysicalReceiptLabelOverrideSection = () => {
  return (
    <Grid container spacing={3}>
      <Grid xs={12}>
        <Typography variant='subtitle1'>Physical Receipt Label Override</Typography>
        <Typography variant='body2' color='text.secondary'>
          {PHYSICAL_RECEIPT_LABEL_OVERRIDE_HELPER_TEXT}
        </Typography>
      </Grid>

      <Grid xs={12} sm={6}>
        <TextField
          name={`${formNamePrefix}.shortDescription` satisfies MarketingContentFormValuesPaths}
          label='Short Description Label Override Text'
        />
      </Grid>

      <Grid xs={12} sm={6}>
        <TextField
          name={`${formNamePrefix}.longDescription` satisfies MarketingContentFormValuesPaths}
          label='Long Description Label Override Text'
        />
      </Grid>
    </Grid>
  );
};
